import { render, staticRenderFns } from "./AddProjectPanel.vue?vue&type=template&id=3fa6c220&scoped=true&"
import script from "./AddProjectPanel.vue?vue&type=script&lang=js&"
export * from "./AddProjectPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectPanel.vue?vue&type=style&index=0&id=3fa6c220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6c220",
  null
  
)

export default component.exports